module.exports = __webpack_public_path__ + "static/media/IMG_0320.616f419d.JPG";